
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.805 22.726c-.6 0-.7 1.2-.7 1.6 0 .7 0 1.3-.1 2 0 .4.1 1.6.7 1.6s.7-1.2.7-1.6c0-.7 0-1.3.1-2 0-.4-.1-1.6-.7-1.6zM35.705 37.776c.075-1.95.15-3.9.2-5.85.1-1.9 1.5-1.9 1.4 0-.05 1.95-.125 3.9-.2 5.85-.075 1.95-.15 3.9-.2 5.85-.1 1.9-1.5 1.9-1.4 0 .05-1.95.125-3.9.2-5.85z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45.705 13.726c-1.217-1.703-3.816-1.564-5.929-1.45-.49.026-.956.05-1.37.05h-2.7c-.3-1.4-.9-2.8-2.1-3.7-1.067-.621-2.21-.612-3.434-.602l-.467.002c-.215 0-.437-.006-.661-.013-1.028-.03-2.118-.061-2.939.513-1.4.8-2.1 2.3-2.4 3.8a66.418 66.418 0 01-1.78-.107c-1.932-.133-3.97-.273-5.72.107-2.8.6-4.2 4.3-2.4 6.8.6.9 1.6 1.3 2.6 1.4.1 2.8.175 5.6.25 8.4.075 2.8.15 5.6.25 8.4.019.708-.018 1.59-.059 2.562-.178 4.247-.428 10.225 3.56 11.038 1.824.406 3.968.263 6 .128.975-.065 1.924-.128 2.8-.128.895 0 1.792.011 2.692.023 1.81.022 3.637.044 5.507-.023 5.087-.172 5.045-4.062 5-8.08a58.82 58.82 0 010-1.92l.6-20.4h.1c.1 0 .2 0 .2-.1 2.7-.8 4.2-4.2 2.4-6.7zm-16-2.5c1.6 0 3.3 0 4.1 1.1h-8.3c1-1.1 2.6-1.1 4.2-1.1zm9.3 36.6c-1.884.404-4.085.265-6.206.13-1.032-.065-2.045-.13-2.994-.13-.949 0-1.962.065-2.994.13-2.121.135-4.322.274-6.206-.13-2.51-.566-2.332-3.231-2.173-5.605.037-.558.073-1.1.073-1.595-.3-6.7-.5-13.3-.7-19.9.578 0 1.183-.027 1.758-.053.52-.024 1.015-.047 1.442-.047h20.6l-.3 10v.007l-.3 9.993c0 .5.044 1.058.09 1.638.182 2.327.392 5.002-2.09 5.562zm4.2-30.4h-26.4c-.5-.3-1.4-1.1-.5-2 .452-.376 2.721-.185 4.112-.068.455.038.816.068.988.068h23.8c-.3 1-.9 1.6-2 2z"}})])
          )
        }
      }
    